"use client";

import React from "react";
import Image from "next/image";
import ShadowCard from "@/components/common/ShadowCard";

export default function LicensingSection() {
  return (
    <section className="bg-brand-black relative w-full px-4 py-8 md:py-[200px] lg:px-20">
      <div className="mx-auto max-w-[1200px]">
        <ShadowCard className="relative overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0 z-0">
            <Image
              src="/regulatory_ship.webp"
              alt="Regulatory background"
              fill
              className="object-cover object-center opacity-60"
              priority
            />
            {/* Dark overlay for better text readability */}
            <div className="absolute inset-0 bg-linear-to-r from-black/80 via-black/60 to-transparent" />
          </div>

          {/* Content */}
          <div className="relative z-10 flex flex-col p-6 md:flex-row md:items-center md:p-10 lg:px-10 lg:py-[65px]">
            {/* Text Content */}
            <div className="flex-1 md:max-w-[60%] lg:max-w-[55%]">
              {/* Subtitle */}
              <p className="mb-2.5 text-[16px] font-medium text-white">
                COAM Class B
              </p>

              {/* Title */}
              <h2 className="mb-2.5 text-[24px] leading-tight font-bold text-white md:text-[32px]">
                Licensing Made Easy
              </h2>

              {/* Intro paragraph */}
              <p className="mb-4 text-[16px] leading-relaxed text-white md:mb-5">
                We provide everything you need to start setting up your COAMs!
              </p>

              {/* Main description */}
              <p className="mb-5 text-[16px] leading-[1.3] text-white/90">
                Need to get your Georgia Lottery COAM Location License?
                Don&apos;t take the task on yourself, let Halcyon Amusements
                help. Our operators and technicians have collected a variety of
                helpful recourses to jump-start your COAM machine success. From
                walking you through the license application process
                step-by-step, to reviewing important laws and GLC regulations,
                we provide everything you need to start setting up your COAMs!
              </p>

              {/* Source info */}
              <p className="text-[16px] text-white">
                All information was pulled from{" "}
                <a
                  href="https://www.gacoam.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-red underline transition-colors hover:text-[#ff5a51]"
                >
                  www.gacoam.com
                </a>
              </p>
            </div>

            {/* Right side spacer for the background image to show through */}
            <div className="hidden md:block md:flex-1" />
          </div>
        </ShadowCard>
      </div>
    </section>
  );
}
